export type ChannelNotificationMode = 'all_messages' | 'mentions' | 'nothing';

export const CHANNEL_MUTE_MINUTES = {
  fifteen_minutes: 15,
  one_hour: 60,
  three_hours: 180,
  eight_hours: 480,
  one_day: 1440,
  one_week: 10080,
  thirty_days: 43200,
} as const;

export type ChannelMuteDuration =
  | keyof typeof CHANNEL_MUTE_MINUTES
  | 'indefinite'
  | 'unmuted';

// Finite sentinel compatible with the existing persisted timestamp contract.
export const INDEFINITE_CHANNEL_MUTE = Number.MAX_SAFE_INTEGER;

export function resolveChannelMuteUntil(
  duration: ChannelMuteDuration,
  now: number
): number | null {
  if (duration === 'unmuted') return null;
  if (duration === 'indefinite') return INDEFINITE_CHANNEL_MUTE;
  return now + CHANNEL_MUTE_MINUTES[duration] * 60_000;
}

export function allowsChannelNotification({
  notificationMode = 'mentions',
  mutedUntil,
  isMention,
  now,
}: {
  notificationMode?: ChannelNotificationMode;
  mutedUntil?: number | null;
  isMention: boolean;
  now: number;
}): boolean {
  if (mutedUntil != null && mutedUntil > now) return false;
  return (
    notificationMode === 'all_messages' ||
    (notificationMode === 'mentions' && isMention)
  );
}
